module.exports = __webpack_public_path__ + "static/media/MinionPro-Regular.d2f4c624.svg";